module.exports = __webpack_public_path__ + "img/videomissarrow.06a5a49d.svg";